export const PAGE_SIZE_OPTIONS: Array<{ value: number; viewValue: string }> = [
    { value: 5, viewValue: '5 Rows' },
    { value: 10, viewValue: '10 Rows' },
    { value: 15, viewValue: '15 Rows' },
    { value: 20, viewValue: '20 Rows' },
    { value: 25, viewValue: '25 Rows' },
    { value: 30, viewValue: '30 Rows' },
    { value: 50, viewValue: '50 Rows' },
    { value: 75, viewValue: '75 Rows' },
    { value: 100, viewValue: '100 Rows' },
];

export const DROPDOWN_DOWN_ICON_CLASS = 'pi pi-chevron-down';
